import React from 'react';
import { LucideProps } from 'lucide-react';

export interface IconProps extends Omit<LucideProps, 'size'> {
  icon: React.ComponentType<LucideProps>;
  size?: number | string;
  strokeWidth?: number;
  color?: string;
  fill?: string;
  className?: string;
}

const Icon: React.FC<IconProps> = ({
  icon: IconComponent,
  size = 24,
  strokeWidth = 2,
  color = 'black',
  fill,
  className = '',
  absoluteStrokeWidth = false,
  ...rest
}) => {
  return (
    <IconComponent
      size={size}
      strokeWidth={strokeWidth}
      color={color}
      {...(fill ? { fill } : {})}
      className={className}
      absoluteStrokeWidth={absoluteStrokeWidth}
      {...rest}
    />
  );
};

export default Icon;
